import { BrowserMultiFormatReader } from '@zxing/library';

const decodeFromImage = async (
  codeReader: BrowserMultiFormatReader,
  image: HTMLImageElement,
): Promise<string | null> => {
  try {
    const result = await codeReader.decodeFromImageElement(image);
    return result.getText();
  } catch {
    return null;
  }
};

const preprocessImage = async (
  originalImage: HTMLImageElement,
): Promise<HTMLImageElement> => {
  // increase contrast to help zxing detect hard-to-read QR codes
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d')!;
  canvas.width = originalImage.width;
  canvas.height = originalImage.height;
  ctx.drawImage(originalImage, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  for (let i = 0; i < imageData.data.length; i += 4) {
    const avg =
      (imageData.data[i] + imageData.data[i + 1] + imageData.data[i + 2]) / 3;
    const value = avg > 128 ? 255 : 0;
    imageData.data[i] = imageData.data[i + 1] = imageData.data[i + 2] = value;
  }
  ctx.putImageData(imageData, 0, 0);

  const preprocessedImage = new Image();
  preprocessedImage.src = canvas.toDataURL();

  await new Promise((resolve) => {
    preprocessedImage.onload = resolve;
  });

  return preprocessedImage;
};

export const qrUtils = {
  decodeFromImage,
  preprocessImage,
};
